import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CalcShell } from "./CalcShell";
import { ContactStep } from "./ContactStep";
import { ResultView } from "./ResultView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// steps: [{ id, skip?(answers), render: ({ answers, set, next }) => JSX }]
export const CalcWizard = ({ title, product, steps, initialAnswers = {} }) => {
  const [answers, setAnswers] = useState(initialAnswers);
  const [index, setIndex] = useState(0);
  const [history, setHistory] = useState([]);
  const [contact, setContact] = useState({ prenom: "", nom: "", telephone: "", email: "", rgpd: false });
  const [leadId, setLeadId] = useState(null);
  const [result, setResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const visible = steps.filter((s) => !s.skip?.(answers));
  const total = visible.length + 1;
  const current = visible[index];

  const set = (patch) => setAnswers((a) => ({ ...a, ...patch }));
  const next = (patch = {}) => {
    const merged = { ...answers, ...patch };
    setAnswers(merged);
    setHistory((h) => [...h, index]);
    const nextVisible = steps.filter((s) => !s.skip?.(merged));
    const pos = current ? nextVisible.findIndex((s) => s.id === current.id) + 1 : nextVisible.length;
    setIndex(pos);
  };
  const back = () => {
    setIndex(history[history.length - 1]);
    setHistory((h) => h.slice(0, -1));
  };

  const submit = async (savedLeadId) => {
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/calc/quote`, { lead_id: savedLeadId || leadId, product, answers, contact });
      setLeadId(res.data.lead_id);
      setResult(res.data.result);
    } catch (e) {
      toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Une erreur est survenue");
    }
    setSubmitting(false);
  };

  if (result) {
    return (
      <CalcShell title={title} stepIndex={total - 1} totalSteps={0} stepKey="result">
        <ResultView leadId={leadId} result={result} title={title} />
      </CalcShell>
    );
  }

  return (
    <CalcShell title={title} stepIndex={index} totalSteps={total} stepKey={current?.id || "contact"} onBack={history.length ? back : null}>
      {current ? (
        current.render({ answers, set, next })
      ) : (
        <ContactStep product={product} answers={answers} contact={contact} setContact={setContact}
          leadId={leadId} setLeadId={setLeadId} onSubmit={submit} submitting={submitting} />
      )}
    </CalcShell>
  );
};
